import UtilsService from '@/core/services/utils.service';

export class Applications {
    public static manager = 'manager';
    public static clickbuy = 'clickbuy';
}

// tslint:disable-next-line:max-classes-per-file
export default class AppService {

    public static checkDomain() {
        switch (location.host) {
            case process.env.VUE_APP_CLICKANDBUY_DOMAIN:
                UtilsService.setCookie('current-app', Applications.clickbuy);
                break;
            case process.env.VUE_APP_MANAGER_DOMAIN:
                UtilsService.setCookie('current-app', Applications.manager);
                break;
        }
    }

    public static current() {
        AppService.checkDomain();
        let currentApp = UtilsService.getCookie('current-app');
        if (!currentApp) {
            currentApp = Applications.manager;
        }
        return currentApp;
    }

    public static changeApp(app: Applications) {
        switch (app) {
            case Applications.manager:
                location.host = process.env.VUE_APP_MANAGER_DOMAIN || location.host;
                break;
            case Applications.clickbuy:
                location.host = process.env.VUE_APP_CLICKANDBUY_DOMAIN || location.host;
                break;
            default:
                // tslint:disable-next-line:no-console
                console.error('App not defined');
        }
    }
}
